import React from 'react';
import { createRoot } from 'react-dom/client';
import DifyChatbot from './components/DifyChatbot';

const CONTAINER_ID = 'lambo-dify-chatbot-root';

let accessRequest: Promise<boolean> | null = null;

function hasLicenceAccess(): Promise<boolean> {
  const nid = drupalSettings.lambo_ai?.node_id;
  if (!nid) {
    return Promise.resolve(false);
  }

  if (!accessRequest) {
    accessRequest = fetch(`/lambo_ai/licence-access/${nid}`, {
      credentials: 'same-origin',
    })
      .then((response) => (response.ok ? response.json() : Promise.reject()))
      .then((data) => Boolean(data?.access))
      .catch(() => false);
  }

  return accessRequest;
}

function mountChatbot() {
  if (!document.body || document.getElementById(CONTAINER_ID)) {
    return;
  }

  hasLicenceAccess().then((access) => {
    if (!access || !document.body || document.getElementById(CONTAINER_ID)) {
      return;
    }

    const container = document.createElement('div');
    container.id = CONTAINER_ID;
    document.body.appendChild(container);

    const root = createRoot(container);
    root.render(
      React.createElement(DifyChatbot, {
        apiKey: drupalSettings.lambo_ai?.dify_api_key || '',
        appKey: drupalSettings.lambo_ai?.dify_app_key || '',
        apiBaseUrl: drupalSettings.lambo_ai?.dify_api_base || 'https://ai.lambo.nl/v1',
      })
    );
  });
}

Drupal.behaviors.lamboAiChatbot = {
  attach() {
    mountChatbot();
  },
};
